var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-list-timeline__item"},[_c('span',{staticClass:"kt-list-timeline__badge"}),_c('span',{staticClass:"kt-list-timeline__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }